module.exports = __webpack_public_path__ + "media/site/images/app-preview/dashboard-98a5473b8a2250635a9f0a705b5dce48.png";